import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-members-directory',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './members-directory.component.html',
  styleUrls: ['./members-directory.component.scss']
})
export class MembersDirectoryComponent implements OnInit {
  form:UntypedFormGroup
  constructor() { }

  ngOnInit() {
  }

}
